import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';
import { OPCO_USER_STATUSES } from '../../const/const';

export const OPCO_USER_STATUS_MAP: StatusType = {
  [OPCO_USER_STATUSES.ACTIVE]: { title: 'Active', variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [OPCO_USER_STATUSES.BLOCKED]: { title: 'Blocked', variant: STATUS_VARIANT_HIGHLIGHT.GREY },
  [OPCO_USER_STATUSES.INVITED]: { title: 'Invited', variant: STATUS_VARIANT_HIGHLIGHT.LIGHT_PURPLE },
  [OPCO_USER_STATUSES.REINVITED]: { title: 'Reinvited', variant: STATUS_VARIANT_HIGHLIGHT.LIGHT_PURPLE },
  [OPCO_USER_STATUSES.UNCONFIRMED]: { title: 'Unconfirmed', variant: STATUS_VARIANT_HIGHLIGHT.ROSE },
};
